import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

// TODO-COMMON
import { ApiService } from '../api/api.service';

declare var $: any;

@Injectable({
    providedIn: 'root'
})
export class SemanticSearchService {
    apiSettings: any;

    constructor(private apiService: ApiService, private cookieService: CookieService) {
        var token = this.cookieService.get('token').replace(' ', ':');

        if (!token) {
            token = localStorage.getItem('calendarHeroToken').replace(' ', ':');
        }

        this.apiSettings = {
            base: this.apiService.apiUrl,
            api: {
                'get recent contacts': 'contact?filter=recent',
                'get contacts': 'contact?search={query}&includeTeams=true',
                'get org users': 'user/collaborators?search={query}'
            },
            beforeXHR: (xhr) => {
                xhr.setRequestHeader('Authorization', `Basic ${window.btoa(token)}`);
                return xhr;
            }
        };

        // Requirement for semantic to add to jquery
        $.fn.api.settings = {
            ...$.fn.api.settings,
            ...this.apiSettings
        };
    }
}
